import React from "react";

const Modal = (props) => {
    return (
        <div className="fixed z-10 inset-0 overflow-auto flex items-center justify-center p-4">
            <div className="bg-gray-900/50 backdrop-blur-sm fixed inset-0 animate-fade-in"></div>
            <div className="relative bg-white rounded-2xl shadow-2xl ring-1 ring-gray-950/5 transform transition-all w-full max-w-3xl max-h-screen overflow-auto animate-scale-in">
                {props.children}
            </div>
        </div>
    );
}

export default Modal;
